import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { RevealFade } from "../fx/Common";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.VARS = {
      EMPTY_SPACE: 2000,
      offsetStartSticky: "top 35px",
    };
    if (Env.mobileCSS) {
      this.VARS.offsetStartSticky = "top 25px";
    }

    //! Fns
    setTimeout(() => {
      this._fx();
    }, Env.timingDelayFx);
  }

  _fx() {
    if (
      this.DOM.view.querySelector("figure").classList.contains("alignfull") ||
      (this.DOM.view.querySelector("figure").classList.contains("size-full") &&
        this.DOM.view.querySelector("figure").classList.contains("mobile-only"))
    ) {
      this.animate();
      this.makeSticky();
      this.animateSticky();
    } else {
      RevealFade(this.DOM.view);
    }
  }

  animate() {
    this.animation = gsap.timeline({
      scrollTrigger: {
        trigger: this.DOM.view,
        start: "top 45%",
        markers: false,
      },
    });
    const posY = Env.mobileCSS ? 50 : 300;
    this.animation.add([
      gsap.fromTo(
        this.DOM.view.querySelector("figure"),
        {
          autoAlpha: 0,
          y: posY,
        },
        {
          autoAlpha: 1,
          y: 0,
          ease: "cubic.out",
          duration: 1.5,
        }
      ),
    ]);
  }

  animateSticky() {
    this.animationSticky = gsap.timeline({
      scrollTrigger: {
        trigger: this.DOM.view,
        start: this.VARS.offsetStartSticky,
        end: `+=${this.VARS.EMPTY_SPACE}px`,
        scrub: 1,
      },
    });

    this.animationSticky.add([
      gsap.fromTo(
        this.DOM.view.querySelector("img"),
        {
          scale: 0.5,
        },
        {
          scale: 1,
          ease: "linear",
          duration: 0.8,
        }
      ),
    ]);
  }

  makeSticky() {
    this.sticky = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: this.VARS.offsetStartSticky,
      end: () => {
        const viewport = Env.framework.toolbox.getViewport();
        return `+=${viewport.height + this.VARS.EMPTY_SPACE}px`;
      },
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true,
    });
  }

  unmount() {
    if (typeof this.sticky != "undefined") {
      this.sticky.kill(true);
    }
  }
}
